import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsxs(Svg, _object_spread_props(_object_spread({
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M8.25 2.5C7.184 2.5 6.26021 3.111 5.80371 4H18.75C19.4395 4 20 4.5605 20 5.25V18.1963C20.889 17.7403 21.5 16.816 21.5 15.75V5.25C21.5 3.734 20.266 2.5 18.75 2.5H8.25ZM5.25 5.5C3.734 5.5 2.5 6.734 2.5 8.25V18.75C2.5 20.266 3.734 21.5 5.25 21.5H15.75C17.266 21.5 18.5 20.266 18.5 18.75V8.25C18.5 6.734 17.266 5.5 15.75 5.5H5.25Z",
                fill: "#03F5AE"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5.25 5.5C3.734 5.5 2.5 6.734 2.5 8.25V18.75C2.5 20.266 3.734 21.5 5.25 21.5H15.75C17.266 21.5 18.5 20.266 18.5 18.75V8.25C18.5 6.734 17.266 5.5 15.75 5.5H5.25Z",
                fill: "white"
            })
        ]
    }));
};
export default Icon;
